import React, { useEffect, useState } from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    FbTab,
    FbTabs,
    GridContainer,
    GridItem,
    Icons,
} from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import axios from 'axios'
import Swal from 'sweetalert2'
import { get as _get } from 'lodash'
import Navigation from '../constants/navigation'
import getEnvVars from '../environment/environment'
import { CardElement } from '../components/DashboardItems/CardElement'
import { Materials } from './Administration/Materials'
import { Packagetypes } from './Administration/Packagetypes'
import { Boxtypes } from './Administration/Boxtypes'
import { Storageconfigs } from './Administration/Storageconfigs'

interface MasterdataPageProps {}

export const MasterDataTab = {
    materials: 0,
    pkgTypes: 1,
    boxTypes: 2,
    storageConfigs: 3,
}

export const Masterdata: React.FC = (props: MasterdataPageProps) => {
    const [keycloak] = useKeycloak()
    const { tab } = useParams()
    // @ts-ignore
    const [activeTab, setTab] = useState(MasterDataTab[tab || 'materials'])
    const [filter, setFilter] = useState<any>({
        filter: new URLSearchParams(useLocation().search).get('filter'),
    })
    const history = useHistory()

    useEffect(() => {
        if (tab) {
            // @ts-ignore
            setTab(MasterDataTab[tab])
            setFilter(null)
        }
    }, [tab])

    const getColor = (props: any) => {
        if (props.isDragAccept) {
            return '#00e676'
        }
        if (props.isDragReject) {
            return '#ff1744'
        }
        if (props.isDragActive) {
            return '#2196f3'
        }
        return '#eeeeee'
    }

    const Container = styled.div`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-width: 2px;
        border-radius: 2px;
        border-color: ${props => getColor(props)};
        border-style: dashed;
        background-color: #fafafa;
        color: #bdbdbd;
        outline: none;
        transition: border 0.24s ease-in-out;
        margin-bottom: 20px;
    `

    function StyledDropzone(props: any) {
        const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
            accept: 'application/zip',
            onDrop: files => handleOnDrop(files),
        })

        function handleOnDrop(acceptedFiles: any) {
            const uploaders = acceptedFiles.map((file: any) => {
                const formData = new FormData()
                formData.append('file', file)

                return axios
                    .post(getEnvVars.calcService.uploads.materials, formData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            Authorization: keycloak.token ? `Bearer ${keycloak.token}` : '',
                        },
                    })
                    .then((response: any) => {
                        const { data } = response
                        Swal.fire({
                            title: 'SUCCESS',
                            text: 'Data is being sucessfully uploaded and processed now.',
                            icon: 'success',
                            confirmButtonText: 'Ok',
                        })
                    })
            })
        }

        return (
            <div className="container">
                <Container {...getRootProps({ className: 'dropzone', isDragActive, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Drag 'n' drop some files here, or click to select files</p>
                </Container>
            </div>
        )
    }

    const renderTab = () => {
        if (activeTab === MasterDataTab.materials) {
            return <Materials filter={{ isInvalid: _get(filter, 'filter', '') === 'isInvalid' }} />
        }
        if (activeTab === MasterDataTab.pkgTypes) {
            return <Packagetypes />
        }
        if (activeTab === MasterDataTab.boxTypes) {
            return <Boxtypes />
        }
        if (activeTab === MasterDataTab.storageConfigs) {
            return <Storageconfigs />
        }
    }
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="plain">
                        <FbTabs
                            centered
                            activeTabIndex={activeTab}
                            didChangeTab={(index: number) => {
                                // @ts-ignore
                                const newTab = Object.keys(MasterDataTab).filter(key => MasterDataTab[key] === index)
                                history.push(`/masterdata/${newTab[0]}`)
                            }}
                        >
                            <FbTab label="Materials" value={0} />
                            <FbTab label="Package Types" value={1} />
                            <FbTab label="Box Types" value={2} />
                            <FbTab label="Zone Configurations" value={3} />
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        {renderTab()}
                    </CardBody>
                </Card>
            </GridItem>
            {/*             <GridItem xs={12} sm={12} md={12}>
               <Card className="card graph">
                    <CardHeader color="primary" isStats={false} type={"plain"}>
                        <CardTitle color={"white"} align={"left"} title="Upload Masterdata" variant={"h5"} />
                    </CardHeader>
                    <CardBody align={"center"}>
                        <StyledDropzone />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={2}>
                <CardElement styles={{ cursor: "Pointer" }} title={"Materials"} icon={<Icons.Receipt />}
                             data={""}
                             valid={"Read only"}
                             onClick={() => {
                                 history.push(Navigation.Materials.path)
                             }}
                />
            </GridItem>
            <GridItem xs={12} sm={4} md={2}>
                <CardElement styles={{ cursor: "Pointer" }} title={"Packagetypes"} icon={<Icons.Redeem />}
                             data={""}
                             valid={"Read only"}
                             onClick={() => {
                                 history.push(Navigation.Packagetypes.path)
                             }}
                />
            </GridItem>
            <GridItem xs={12} sm={4} md={2}>
                <CardElement styles={{ cursor: "Pointer" }} title={"Boxtypes"} icon={<Icons.Inbox />}
                             data={""}
                             valid={"Edit"}
                             onClick={() => {
                                 history.push(Navigation.Boxtypes.path)
                             }}
                />
            </GridItem>
            <GridItem xs={12} sm={4} md={2}>
                <CardElement styles={{ cursor: "Pointer" }} title={"Zone Configurations"} icon={<Icons.ZoomOutMap />}
                             data={""}
                             valid={"Edit"}
                             onClick={() => {
                                 history.push(Navigation.Storageconfigs.path)
                             }}
                />
            </GridItem> */}
        </GridContainer>
    )
}
